module.exports = __webpack_public_path__ + "left.png?d44565dedbe808c9df60aff8d729f880";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/LCStudies/left.png
// module id = 190
// module chunks = 0